module.exports = __webpack_public_path__ + "img/shippingBannerLalamove.25793c3a.png";